import React from "react";
import { ErrorMessage } from "formik";
import Icon from "../common/Icon";

function CMSFormCheckBox(props) {
  const { label, name, className, options = [], form, required, ...rest } = props;
  const isSingleCheckbox = options.length === 0;

  // helper fn to interpret various truthy values
  const isTruthy = (val) => val === "1" || val === 1 || val === true;

  return (
    <div className="cursor-pointer relative ms-1">
      <div
        role="group"
        aria-labelledby={`checkbox-group-${name}`}
        className={`${form.touched[name] && form.errors[name] ? "is-invalid" : ""}`}
      >
        <div className="flex flex-col">
          {isSingleCheckbox ? (
            <label
              className={`${
                form.touched[name] && form.errors[name]
                  ? "isInvalidText checkboxText mb-2 radio text-green"
                  : "checkboxText radio text-green"
              }`}
            >
              <input
                type="checkbox"
                name={name}
                checked={isTruthy(form.values[name])} // ✅ supports "1", 1, or true
                onChange={() => {
                  const current = isTruthy(form.values[name]);
                  form.setFieldValue(name, current ? "0" : "1"); // ✅ stores as "1"/"0"
                }}
                className="hidden"
                {...rest}
              />
              <span className="mr-2 text-xl">
                {isTruthy(form.values[name]) ? (
                  <Icon
                    icon="checked"
                    className={className === "small" ? "w-4 h-4" : "w-6 h-6"}
                  />
                ) : (
                  <Icon
                    icon="checkbox"
                    className={className === "small" ? "w-4 h-4" : "w-6 h-6"}
                  />
                )}
              </span>
              <span className="ms-2">{label}</span>
            </label>
          ) : (
            options.map((option, index) => {
              const currentValues = form.values[name] || [];
              const isChecked = currentValues.includes(option.value);

              return (
                <label
                  key={index}
                  className={`${
                    form.touched[name] && form.errors[name]
                      ? "isInvalidText checkboxText mb-2 radio"
                      : "checkboxText radio"
                  }`}
                >
                  <input
                    type="checkbox"
                    name={name}
                    value={option.value}
                    checked={isChecked}
                    onChange={() => {
                      if (isChecked) {
                        form.setFieldValue(
                          name,
                          currentValues.filter((v) => v !== option.value)
                        );
                      } else {
                        form.setFieldValue(name, [...currentValues, option.value]);
                      }
                    }}
                    className="hidden"
                  />
                  <span className="mr-2 text-xl">
                    {isChecked ? (
                      <Icon icon="checked" className="w-4 h-4" />
                    ) : (
                      <Icon icon="checkbox" className="w-4 h-4" />
                    )}
                  </span>
                  <span className="ms-2">{option.label}</span>
                </label>
              );
            })
          )}
        </div>
      </div>

      {form.touched[name] && form.errors[name] && (
        <span id={`${name}-error`} className="errorMessage invalid-feedback">
          <ErrorMessage name={name} />
        </span>
      )}
    </div>
  );
}

export default CMSFormCheckBox;
